import React from 'react';
import { Paper, withStyles } from '@material-ui/core';
import * as Yup from "yup";
import UnpairedPaletteForm from "./UnpairedPaletteForm";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../sc-utilities';
import * as actions from './store/unpairedPaletteActions';
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    }
});

const UnpairedPaletteCreateFromExternal = props => {
    let { createFromExternal, permissions, activeCustomer, classes, translations, loading } = props;

    const handleSubmit = async data => {
        let result = await createFromExternal({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    }

    let initialValues = {
        Type: "Order",
        ExternalID: "",
    };

    let formSettings = {
        Validation: {
            ExternalID: Yup.string().required("Required")
        },
        FormTitle: translations['create_unpaired_dialog_title'] || ' Create palette/order from external system',
        SecondTitle: translations['create_unpaired_dialog_content_0'] || 'Choose type and enter external ID.',
        ThirdTitle: translations['create_unpaired_dialog_content_1'] || 'Please be careful when entering external ID.',
        ReportData: true,
        ButtonSubmit: hasPermission(permissions, 'unpaired_palette_create_from_external') ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <UnpairedPaletteForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                loading={loading}
                translations={translations}
            />
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createFromExternal: data => dispatch(actions.createFromExternal(data))
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UnpairedPaletteCreateFromExternal));